module.exports = __webpack_public_path__ + "img/anatomy.4c6c88d3.svg";